angular.module('gym.calendar').directive('editEventScheduleNotes', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/edit_event_schedule_notes.html.slim'),
    scope: {
      event: '=',
      permissions: '=',
      onSave: '&'
    },
    controller: ["$scope", "flash", "GTMService", function($scope, flash, GTMService) {
      $scope.initialValue = $scope.event.notes;
      return $scope.save = function() {
        var params;
        GTMService.trackPage('Event details', 'Save note');
        params = {
          notes: $scope.event.notes,
          rootObjectName: 'event'
        };
        return $scope.event.doPUT(params, 'update_notes').then(function() {
          $scope.onSave({
            notes: $scope.event.notes
          });
          $scope.initialValue = $scope.event.notes;
          return flash.success = 'Saved successfully';
        });
      };
    }]
  };
});
